import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const UserComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  return (
    <CRUD
      cssClass="modalRight"
      isModal={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("users") ?? ""}
      getRecordsPath={`users/list?OrganizationId=${user.OrganizationId}`}
      addEditRecordPath={`users/AddEditUser?refer=${window.location.host}`}
      deleteRecordPath="users/Delete"
      fieldsList={[
        {
          name: "firstName",
          title: t("First Name"),
        },
        {
          name: "lastName",
          title: t("Last Name"),
        },
        {
          name: "email",
          title: t("Email"),
        },
        {
          name: "color",
          title: t("Color"),
          htmlType: "color",
          cssClass: "text-center",
        },
        {
          name: "organizationRoleName",
          title: t("Role"),
        },
        { name: "reference", title: t("Reference"), },
      ]}
      fields={[
        {
          name: "id",
          htmlType: "hidden",
          dbType: "string",
        },
        {
          name: "firstName",
          htmlType: "text",
          dbType: "string",
          title: t("First Name") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },
        {
          name: "lastName",
          htmlType: "text",
          dbType: "string",
          title: t("Last Name") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
        },
        {
          name: "email",
          htmlType: "email",
          dbType: "string",
          title: t("Email") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },

        {
          name: "password",
          htmlType: "password",
          dbType: "string",
          title: t("Password") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
        },

        {
          name: "organizationRoleId",
          htmlType: "select",
          dbType: "string",
          title: t("Role") ?? "",
          containerClass: "col-12 col-md-6",
          dataSource:
            "organization/roles?OrganizationId=" + user.OrganizationId,
          dataSourceTextField: "name",
          dataSourceValueField: "id",
          required: true,
        },
        {
          name: "organizationId",
          htmlType: "hidden",
          dbType: "string",
          //title: t("value")??"",
          containerClass: "col-6",
          required: true,
          value: user.OrganizationId,
        },
        {
          name: "CurrentUserId",
          htmlType: "hidden",
          dbType: "string",
          //title: t("value")??"",
          containerClass: "col-6",
          required: true,
          value: user.ID,
        },
        {
          name: "color",
          htmlType: "color",
          dbType: "string",
          title: t("Color") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
        }, {
          name: "reference",
          htmlType: "text",
          dbType: "string",
          title: t("Reference") ?? "",
          containerClass: "col-12 col-md-6",
          required: false,
        },
      ]}
    />
  )
}

export default UserComponent
